module.exports = __webpack_public_path__ + "img/pet10.10de70dd.png";